export const deleteButtonTemplate = () => `
  <button type="button"
    class="text-chilired text-14 font-medium leading-18 hover:underline"
    data-action="click->question#delete">
    Delete question
  </button>
`

export const questionTemplate = ({ question, index, answersHtml, questionErrors, predefinedAnswerErrors }) => {
  const escapedQuestionJson = JSON.stringify(question).replace(/'/g, "&#39;")
  const escapedPredefinedAnswerErrors = JSON.stringify(predefinedAnswerErrors || {}).replace(/'/g, "&#39;")
  const escapedQuestionErrors = JSON.stringify(questionErrors || {}).replace(/'/g, "&#39;")

  return `
    <div class="content-section-md bg-seasalt p-20 rounded-15"
         data-controller="question"
         data-question-index-value="${index}"
         data-question-question-value='${escapedQuestionJson}'
         data-question-predefined-answer-errors-value='${escapedPredefinedAnswerErrors}'
         data-question-question-errors-value='${escapedQuestionErrors}'>
      <div class="content-section-sm">
        <div class="flex items-center justify-between gap-10">
          <h4 class="ui-text-label font-medium">Question ${index + 1}</h4>
          <label class="checkbox-switch flex items-center gap-6 2xl:gap-8">
            <input type="checkbox"
              class="hidden peer"
              data-question-target="activeToggle"
              data-action="change->question#toggleActive"
              ${question.is_active ? "checked" : ""}>
            <div class="checkbox-switch-toggle peer"></div>
          </label>
        </div>

        <div class="form-group">
          <input type="text"
                 class="form-input form-input--2sm"
                 data-question-target="questionInput"
                 data-action="input->question#updateQuestion"
                 value="${question.question || ""}"
                 placeholder="Enter your question"
                 ${question.question_type === "default" ? "disabled" : ""}>
          <span class="hidden" data-question-target="questionError">
            ${questionErrors.question || ''}
          </span>
        </div>
      </div>

      ${answersHtml}

      <div class="hidden text-chilired mt-10" data-question-target="predefinedAnswersError">
        ${questionErrors.predefined_answers || ''}
      </div>

      <div class="flex items-center justify-between gap-10">
        <label class="flex items-center gap-10 w-fit cursor-pointer">
          <input type="checkbox"
            class="checkbox checkbox--lg"
            data-question-target="mandatoryToggle"
            data-action="change->question#toggleMandatory"
            ${question.is_required ? "checked" : ""}>
          <span>Mandatory</span>
        </label>

        ${question.question_type === "custom" ? deleteButtonTemplate() : ""}
      </div>

      <input type="hidden"
             name="questions[]"
             data-question-target="hiddenInput"
             value='${escapedQuestionJson}'>
    </div>
  `
}
